<template>
    <div :class="classes" v-on:click="clicked()">
        <span><slot></slot></span>
    </div>
</template>
<script>
export default {
  methods: {
    clicked () {
      this.$emit('clicked')
    }
  },
  data () {
    return {
      button_class: 'btn-disabled'
    }
  },
  props: ['button_status', 'selected'],
  watch: {
    button_status: function (val) {
      console.log('BTN CHNAGED TO: ' + val)
      if (val) {
        this.button_class = 'btn-enabled'
      } else {
        this.button_class = 'btn-disabled'
      }
    }
  },
  computed: {
    classes () {
      return {
        [this.button_class]: true,
        'btn-selected': this.selected
      }
    }
  },
  created () {
    if (this.button_status === 0) {
      this.button_class = 'btn-disabled'
    } else {
      this.button_class = 'btn-enabled'
    }
  }
}
</script>
<style>
    .btn-enabled{
        display: inline-block;
        font-family: var(--sl-font);
        font-weight: 800;
        font-size: 14px;
        line-height: 1.2;
        padding: 10px 16px;
        margin: 5px;
        min-width: 50px;
        border: 1px solid rgba(224, 31, 40, 0.5);
        border-radius: 9px;
        background: var(--sl-red-soft);
        color: #ff6167;
        transition: background-color 0.15s, color 0.15s, border-color 0.15s;
        user-select: none;
        cursor: pointer;
    }
    .btn-enabled:hover{
        background: var(--sl-red);
        color: #ffffff;
    }
    .btn-selected{
        background: var(--sl-red);
        border-color: var(--sl-red);
        color: #ffffff;
        box-shadow: 0 6px 16px rgba(224, 31, 40, 0.32);
    }
    .btn-disabled{
        display: inline-block;
        font-family: var(--sl-font);
        font-weight: 800;
        font-size: 14px;
        line-height: 1.2;
        padding: 10px 16px;
        margin: 5px;
        min-width: 50px;
        border: 1px solid var(--sl-line-strong);
        border-radius: 9px;
        background: rgba(255, 255, 255, 0.03);
        color: var(--sl-faint);
        user-select: none;
        cursor: default;
    }
</style>



// WEBPACK FOOTER //
// src/components/button_a.vue